module.exports = __webpack_public_path__ + "assets/kendo-ui.45f019ca.svg";